import { useState, useEffect } from 'react';
import '../../../../css/freelancer-services.css';
import { fetchPublicServices } from '../../../../services/servicesService';

const MyServices = ({ freelancerId }) => {
    const [profileServices, setProfileServices] = useState([]);
    const [isLoading, setLoading] = useState(true);

    // Fetch user's profile services
    useEffect(() => {
        const fetchProfileServices = async () => {
            try {
                setLoading(true);
                const services = await fetchPublicServices(freelancerId);
                setProfileServices(services);
            } catch (error) {
                console.error('Error fetching profile services:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchProfileServices();
    }, []);

    if (isLoading) return null;

    return (
        <div className="info-container">
            <p
                style={{
                    color: "var(--text)",
                    margin: 0,
                    textAlign: profileServices.length === 0 ? "center" : "right",
                }}
            >
                {profileServices.length === 0
                    ? "No Services Listed"
                    : `${profileServices.length} ${profileServices.length === 1 ? "Service" : "Services"}`}
            </p>

            <div className="services-list">
                {profileServices.map((service, index) => (
                    <div key={service.id} className="service-card">
                        <h4>
                            {service.title}
                            {service.is_custom && <span className="custom-tag">Custom</span>}
                        </h4>

                        {service.description && <p>{service.description}</p>}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MyServices;